// Email Styles
export const EMAIL_STYLES = [
  'Secret Shortcut',
  'Show, Don\'t Tell',
  'Oh No You Didn\'t',
  'Everyday Insight'
];

// Email Tones
export const EMAIL_TONES = [
  'Friendly',
  'Honest',
  'Curious',
  'Bold',
  'Realistic',
  'Surprising',
  'Encouraging',
  'Playful',
  'Irreverent'
];

// Offer Snapshot Interface
export const OfferSnapshot = {
  offerName: '', // e.g., "Analog Action"
  offerDescription: '', // e.g., "A weekly planning system to avoid burnout"
  offerPrice: '', // e.g., "$9", "Free", or "Starts at $97"
  offerLink: '' // optional, for friendly CTA reference
};

// Newsletter Topics Interface
export const NewsletterTopics = {
  topics: [] // e.g., ["productivity", "goal setting", "fatherhood", "analog planning"]
};

// User Inputs Interface
export const UserInputs = {
  story: '', // Required: 1–3 sentence moment, story, or insight
  selectedStyle: EMAIL_STYLES[0], // Auto-suggested or manually selected
  tone1: '', // Optional: Primary tone
  tone2: '', // Optional: Secondary tone
  pastNewsletterSample: '', // Optional: A sample newsletter for tone/voice matching
  offerSnapshot: OfferSnapshot, // Optional: Product/offer details for better CTA
  newsletterTopics: NewsletterTopics // Optional: Content categories and themes
};

// Generated Email Interface
export const GeneratedEmail = {
  subject: '', // Primary subject line (best one)
  subjectLines: {
    fomo: '',      // FOMO subject line
    curiosity: '', // Curiosity subject line
    value: '',     // Value subject line
    question: '',  // Question subject line
    special: ''    // Special subject line
  },
  hook: '',    // 1–2 line opening sentence
  body: '',    // ~200 word story-based email
  cta: ''      // Optional call to action (if provided)
};

// Style Descriptions for UI
export const STYLE_DESCRIPTIONS = {
  'Secret Shortcut': 'Get the result without the painful thing',
  'Show, Don\'t Tell': 'Demonstrate results through experience',
  'Oh No You Didn\'t': 'Challenge bad advice or share mistakes',
  'Everyday Insight': 'Simple, personal, or reflective stories'
};

// Style Detection Keywords
export const STYLE_KEYWORDS = {
  'Secret Shortcut': ['shortcut', 'trick', 'hack', 'without', 'easy', 'simple', 'quick', 'fast'],
  'Show, Don\'t Tell': ['result', 'worked', 'success', 'achieved', 'transformed', 'changed'],
  'Oh No You Didn\'t': ['mistake', 'wrong', 'bad', 'avoid', 'never', 'worst', 'failed'],
  'Everyday Insight': ['learned', 'realized', 'noticed', 'discovered', 'thought', 'felt']
}; 